import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var Location = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.999.5c5.47 0 9.913 4.442 9.913 9.913 0 2.756-1.34 5.607-3.067 7.989-2.305 3.18-5.185 5.501-5.21 5.522a2.61 2.61 0 01-3.272 0c-.025-.02-2.905-2.342-5.21-5.522C1.427 16.02.086 13.169.086 10.413.086 4.943 4.528.5 10 .5zm0 1.043c-4.896 0-8.87 3.975-8.87 8.87 0 2.55 1.272 5.173 2.87 7.377 2.23 3.077 5.018 5.32 5.018 5.32.573.462 1.39.462 1.964 0 0 0 2.789-2.243 5.018-5.32 1.597-2.204 2.87-4.827 2.87-7.377 0-4.896-3.974-8.87-8.87-8.87z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.717a4.698 4.698 0 014.695 4.696A4.698 4.698 0 0110 15.11a4.698 4.698 0 01-4.696-4.696A4.698 4.698 0 0110 5.717zm0 1.044a3.654 3.654 0 000 7.304 3.653 3.653 0 000-7.305z",
    fill: "currentColor"
  }));
});
Location.displayName = 'Location';

export { Location, Location as default };
